import { getButtonAuth } from '@/utils/buttonAuthStorage'

const hasPermission = {
    install(Vue, options) {
        // console.log(options);
        Vue.directive('has', {
            inserted: (el, binding, vnode) => {
                // console.time()
                // 节点权限处理，如果命中则不进行全局权限处理
                if (!filterNodePermission(el, binding, vnode)) {
                    filterGlobalPermission(el, binding, vnode)
                }
                // console.timeEnd() //计时结束并输出时长
            }
        })
    }
}

/**
 * 流程节点权限控制
 */
export function filterNodePermission(el, binding, vnode) {
    let permissionList = []
    try {
        let obj = vnode.context.$props.formData
        if (obj) {
            let bpmList = obj.permissionList
            for (let bpm of bpmList) {
                if (bpm.type != '2') {
                    permissionList.push(bpm)
                }
            }
        } else {
            return false
        }
    } catch (e) {
        // console.log("页面权限异常----", e);
    }
    if (permissionList === null || permissionList === '' || permissionList === undefined || permissionList.length <= 0) {
        // el.parentNode.removeChild(el)
        return false
    }

    console.log('流程节点页面权限--NODE--')
    let permissions = []
    for (let item of permissionList) {
        if (item.type != '2') {
            permissions.push(item.action)
        }
    }

    if (!permissions.includes(binding.value)) {
        // el.parentNode.removeChild(el)
        return false
    } else {
        for (let item2 of permissionList) {
            if (binding.value === item2.action) {
                return true
            }
        }
    }
    return false
}

/**
 * 全局权限控制（与 permissionMixin 一致，兼容 path / resourceUri）
 */
export function filterGlobalPermission(el, binding, vnode) {
    const permissionList = getButtonAuth()
    if (permissionList.length === 0) {
        el.parentNode.removeChild(el)
        return
    }
    const permissions = permissionList.map((item) => item.path || item.resourceUri).filter(Boolean)
    if (!permissions.includes(binding.value)) {
        el.parentNode.removeChild(el)
    }
}

export default hasPermission
